module.exports = __webpack_public_path__ + "static/banner-bg-038d96189b88cdcdf079beb7cbb6ba65.png";